export default __webpack_public_path__ + "static/media/add.12b9b0dd.svg";